import axios, { AxiosResponse } from 'axios'
import { IRoleModel, IPermission } from './RoleModel'
import { ApiResponse, PageResponse } from '../../../../shared/models/ApiModels'

const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')

export const ROLE_CREATE_URL  = `${API_URL}api/v1/user/role/create`
export const ROLE_GET_ALL_URL = `${API_URL}api/v1/user/role/roles`
export const ROLE_DELETE_URL  = `${API_URL}api/v1/user/role/`
export const ROLE_UPDATE_URL  = `${API_URL}api/v1/user/role/`
export const PERMISSION_GET_ALL_URL = `${API_URL}api/v1/user/permission/all`
export const MENU_ALL_URL = `${API_URL}api/v1/definition/menu/all` 

export function createRole(role: IRoleModel) {
  return axios.post(ROLE_CREATE_URL, role)
}

export function updateRole(role: IRoleModel) {
  return axios.put(ROLE_UPDATE_URL + role.id, role)
}

export function deleteRole(id: string) {
  return axios.delete(ROLE_DELETE_URL + id)
}

export async function loadRoles(
  page = 0,
  size = 10,
  sort = 'createdDate',
  order = 'desc'
): Promise<AxiosResponse<ApiResponse<PageResponse<IRoleModel>>>> {
  return axios.get(ROLE_GET_ALL_URL, { params: { page, size, sort, order } })
}

export async function loadAllPermissions(): Promise<AxiosResponse<ApiResponse<IPermission[]>>> {
  return axios.get(PERMISSION_GET_ALL_URL)
}

/** menuTreeId verilirse yalnızca o menü ağacının menüleri gelir */
export async function loadAllMenus(menuTreeId?: string): Promise<AxiosResponse<any>> {
  return axios.get(MENU_ALL_URL, { params: menuTreeId ? { menuTreeId } : {} })
}
 
